// ?use_ios_ui — single source of truth for the iOS 0.7.0 look (twin of
// iOS PlacementPalette + the panel's tile chrome). Every ios-ui component
// reads its colours and the tile style from here.

import type { CSSProperties } from 'react'

export const IOS_UI_PALETTE = {
  /** #007AFF, the system blue — the framing ring, Place, Done, Select. */
  accent: '#007AFF',
  onAccent: '#FFFFFF',
  /** #0A84FF, the dark-background variant, for the near-black panel. */
  accentOnDark: '#0A84FF',
  /** white 0.07 @ 0.95 — nearly opaque over a bright camera feed. */
  panelBackground: 'rgba(18, 18, 18, 0.95)',
  /** white 0.11 — a step lighter than the card. */
  tileFill: 'rgb(28, 28, 28)',
  tileStroke: 'rgba(255, 255, 255, 0.08)',
  track: 'rgba(255, 255, 255, 0.18)',
  label: 'rgba(255, 255, 255, 0.55)',
} as const

/** The system font stack the iOS text uses (SF on Apple, Roboto here). */
export const IOS_UI_FONT = '-apple-system, system-ui, "Segoe UI", Roboto, sans-serif'
export const IOS_UI_MONO = 'ui-monospace, "SF Mono", "Roboto Mono", Menlo, monospace'

/** A tile on the panel. While `active` (pressed / dragged) its edge and
 *  fill take the accent. */
export function panelTileStyle(active = false, radius = 12): CSSProperties {
  return {
    background: active ? 'rgba(10, 132, 255, 0.15)' : IOS_UI_PALETTE.tileFill,
    border: `1px solid ${active ? IOS_UI_PALETTE.accentOnDark : IOS_UI_PALETTE.tileStroke}`,
    borderRadius: radius,
    boxSizing: 'border-box',
  }
}

/** MASK, CAMBER, DEPTH: 10px semibold monospaced capitals, tracking 1.5. */
export const PANEL_LABEL_STYLE: CSSProperties = {
  fontFamily: IOS_UI_MONO,
  fontSize: 10,
  fontWeight: 600,
  letterSpacing: 1.5,
  color: IOS_UI_PALETTE.label,
}
